'use client';

import { motion } from 'framer-motion';

export default function AnimatedBackground() {
  return (
    <motion.div
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        background: `
          radial-gradient(circle at 10% 20%, rgba(255, 0, 255, 0.15), transparent 80%),
          radial-gradient(circle at 90% 80%, rgba(0, 255, 255, 0.15), transparent 80%),
          radial-gradient(circle at 50% 50%, rgba(0, 0, 255, 0.15), transparent 80%)
        `,
        filter: 'blur(50px)',
      }}
    />
  );
}